import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany } from 'auth/selectors';
import * as Inpc from 'inpc/components';

class InpcRowContainer extends Component {
  render = () => (
    <Inpc.Row
      inpc={this.props.inpc}
      company={this.props.company}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InpcRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/containers/InpcRowContainer.js